import { gql } from '@apollo/client';

/**
 * Fragment for transmission event details (order/email delivery events)
 */
export const TransmissionEventsFragment = gql`
  fragment TransmissionEventsFragment on TransmissionEvent {
    id
    ofId
    ofIdType
    to
    toType
    newState
    isDeliveryEvent
    isFailureEvent
    timestamp
    metaData
  }
`;
